export enum OfferBubbleColors {
  Default = '',
  LightGrey = 'light-grey',
  GreenFramed = 'bubble-framed green',
  LightBlueFramed = 'bubble-framed primary',
  RedFramed = 'bubble-framed red',
  RedCancelled = 'bubble-cancelled red',
  Yellow = 'yellow',
}
